module.exports = "https://www.niulinkcloud.com/_next/static/media/pcBanner2.9e99873dd0aa3f8d3638900c77564f2d.jpg";